/*
 * Visualiseur InstrumenPoche en Javascript et SVG
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Si on est en dev
 * @type {boolean}
 */
/*
iep.isDev = /(\.devsesamath\.net|\.local)$/.test(window.location.hostname) || window.location.href.substr(0, 7) === "file://";
*/
const kernel = {
  svgsn: 'http://www.w3.org/2000/svg',
  caracteresGrecs: ['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', ' theta', 'kappa',
    'lambda', 'mu', 'nu', 'xi', 'pi', 'rho', 'sigma', 'tau', 'phi', 'chi',
    'psi', 'omega', 'Gamma', 'Delta', 'Xi', 'Pi', 'Sigma', 'Phi', 'Chi', 'Psi', 'Omega'],
  caracteresGrecsUtf8: ['α', 'β', 'γ', 'δ', 'ε', 'ζ', 'η', 'θ', 'κ',
    'λ', 'μ', 'ν', 'ξ', 'π', 'ρ', 'σ', 'τ', 'φ', 'χ',
    'ψ', 'ω', 'Γ', 'Δ', 'Ξ', 'Π', 'Σ', 'Φ', 'Χ', 'Ψ', 'Ω'],
  // Constantes globales utilisés dans les calculs
  convDegRad: Math.PI / 180,
  convRadDeg: 180 / Math.PI,
  sin30: 0.5,
  /**
   * Fonction renvoyant true si le nombre x a une valeur absolue inférieue à 10^-9
   * @param {float} x
   * @returns {boolean}
   */
  zero: function (x) {
    return (Math.abs(x) < 1e-9)
  },
  /**
   * Fonction renvoyant true si la valeur absolue de a est inférieure à 10^-7
   * Utilisé pour tester si un angle est quasi nul.
   * @param {number} a
   * @returns {boolean}
   */
  zeroAngle: function (a) {
    return (Math.abs(a) < 1e-7)
  },
  /**
   * Fonction renvoyant la mesure principale en degrés de l'angle dont ang est une mesure
   * @param {Float} ang
   * @returns {Float}
   */
  mesurePrincDeg: function (ang) {
    const q = Math.floor((ang + 180) / 360)
    let ret = ang - 360 * q
    if (ret === -180) ret = 180
    return ret
  },
  /**
   * Fonction servant à parser un fichier xml contenu dans la chaîne txt
   * @param {string} txt
   * @returns {DOMParser}
   */
  parseXMLDoc: function (txt) {
    let parser, xmlDoc
    if (window.DOMParser) {
      parser = new DOMParser()
      xmlDoc = parser.parseFromString(txt, 'text/xml')
    } else { // Internet Explorer
      xmlDoc = new ActiveXObject('Microsoft.XMLDOM')
      xmlDoc.async = false
      xmlDoc.loadXML(txt)
    }
    return xmlDoc
  },
  /**
   * Fonction renvoyant true si ch contient le nom d'un instrument.
   * @param {type} ch
   * @returns {boolean}
   */
  estInstrument: function (ch) {
    return ch === 'compas' || ch === 'compasLeve' || ch === 'crayon' || ch === 'equerre' ||
      ch === 'rapporteur' || ch === 'regle' || ch === 'requerre'
  },
  /**
   * Fonction appelée pour une chaîne qui commence par un caractère de balise ouvrante.
   * Avant appel la chaîne doit commencer par une balise ouvrante
   * Renvoie -1 s'il n'y a pas de balise fermante correspondante
   * @param {string} ch
   * @returns {int} Renvoie l'indice du dernier caractère de la balise fermante correspondante
   * augmentée de 1
   */
  indiceFinBalise: function (ch) {
    let bal, balf, indf
    let balisefont = false
    if (ch.indexOf('<font') === 0) {
      balf = '</font>'
      balisefont = true
    } else {
      indf = ch.indexOf('>')
      if (indf === -1) return ch.length // Erreur
      bal = ch.substring(0, indf + 1)
      balf = bal.substring(0, 1) + '/' + bal.substring(1)
    }
    const ind = ch.indexOf(balf)
    if (ind === -1) {
      // Il arrive que des gens oublient de fermer une baise font et en ouvrent une autre
      if (balisefont) {
        const ind2 = ch.indexOf('<font', 5)
        if (ind2 !== -1) return ind2
      }
      return -1
    } // Incorrect. Balise de fn oubliée ?
    else return ind + balf.length
  },
  /**
   * Fonction analysant une chaîne commençant par £e( ou £i(
   * et renvoyant un objet formé de l'opérande et de l'exposant (ou indice)
   * @param {type} chaine
   * @returns {kernel.analyseExposantOuIndice.res|Object}
   */
  analyseExposantOuIndice: function (chaine) {
    const ch = chaine.trim()
    const res = {}
    const indvirg = ch.indexOf(',')
    const indparf = ch.indexOf(')')
    res.erreur = (indvirg === -1) || (indparf === -1)
    if (res.erreur) {
      res.texte = ''
      return res
    }
    res.operande = ch.substring(3, indvirg)
    res.exposant = ch.substring(indvirg + 1, indparf)
    res.texte = ch.substring(indparf + 1)
    return res
  },
  /**
   * Fonction appelée dans le cas ou pDebut est l'indice dans chaine d'une
   * parenthèse ouvrante et renvoyant l'indice de la parenthèse
   * fermante correspondante dans la chaîne.
   */
  indiceParentheseFermante: function (chaine, deb) {
    let p; let ch
    let somme = 1
    p = deb + 1
    while (p < chaine.length) {
      ch = chaine.charAt(p)
      if (ch === '(') { somme++ } else {
        if (ch === ')') { somme-- }
      }
      if (somme === 0) break
      p++
    }
    if (somme === 0) return p
    else return -1 // On renvoie -1 si pas trouvé
  },
  /**
   * Fonction renvoyant true si le premier caractère de la chaîne est un chiffre
   * @param {type} car
   * @returns {boolean}
   */
  chiffre: function (car) {
    const s = '0123456789'
    return (s.indexOf(car) !== -1)
  },
  // Fonctions reprises depuis le code source de InstrumentPoche en flash
  valeur_approchee: function (nombre, precision) {
    const prec = Math.pow(10, precision)
    return Math.round(nombre / prec) * prec
  },
  /**
   * Fonction reprise à partir du code de la version Flash et servant pour les
   * repères et quadrillages
   * @param {Float} nbr
   * @param {Float} borne1
   * @param {Float} borne2
   * @param {Float} borne_pix1
   * @param {Float} borne_pix2
   * @returns {Float}
   */
  mettre_en_pixels: function (nbr, borne1, borne2, borne_pix1, borne_pix2) {
    const coeff_dir = (borne_pix1 - borne_pix2) / (borne1 - borne2)
    const ordo_orig = borne_pix1 - coeff_dir * borne1
    return coeff_dir * nbr + ordo_orig
  },
  /** Fonctions éléminant dans le code XML contenu dans la chaîne ch les attributs
   * en doublon en ne gardant que le premier
   * @param {string} ch
   * @returns {string} / La chaîne avec les doublons d'attribut supprimés.
   */
  elimineDoublonsXML: function (ch) {
    let i; let j; let li; let a; let b
    let res = ''
    const liste = ['objet', 'mouvement', 'vitesse', 'tempo', 'abscisse', 'ordonnee', 'id', 'couleur', 'pointille', 'echelle',
      'angle', 'cible', 'texte', 'ecrire', 'rotation', 'translation', 'epaisseur', 'opacite', 'masquer', 'montrer',
      'crayon', 'equerre', 'regle', 'compas', 'reglequerre', 'sens', 'hauteur', 'largeur', 'haut', 'gauche',
      'Xmin', 'Ymin', 'Xmax', 'yMax', 'Xgrad', 'Ygrad', 'image', 'police', 'taille',
      'ordonnee_bas_droite', 'abscisse_bas_droite', 'ordonnee_haut_gauche', 'abscisse_haut_gauche']
    const s = ch.split(/<action/gi)
    for (i = 0; i < s.length; i++) {
      li = s[i]
      for (j = 0; j < liste.length; j++) {
        const r = new RegExp(' ' + liste[j] + '[^\\w ]*= *"[\\w]*"', 'i')
        a = li.search(r)
        if (a !== -1) {
          b = li.substring(a + 1).search(r)
          if (b !== -1) { li = li.replace(r, '') }
        }
      }
      res += (i === 0) ? li : '<action' + li
    }
    return res
  },
  /**
   * Constructeur utilisée dans l'objet kernel.ActionEcrireTexte. L'objet contient les informations
   * sur un texte contenant des balises <b> ou <i> ou <u> ou <font> (ou un mélange)
   * @param {type} bold
   * @param {type} italic
   * @param {type} underline
   * @param {type} couleur
   * @param {type} fontface
   * @param {type} taille
   */
  infoBalise: function (bold, italic, underline, couleur, fontface, taille) {
    this.bold = bold
    this.italic = italic
    this.underline = underline
    this.couleur = couleur
    this.fontface = fontface
    this.taille = taille
  },
  /**
   * Fonction remplaçant dans la chaîne ch les accents écrits en code html par leur caractère utf8
   * @param {string} ch : La chaîne à traiter
   * @returns {string} : La chaîne avec les caractères remplacès
   */
  remplaceAccentsHtml: function (ch) {
    const t1 = ['&agrave;', '&acirc;', '&aelig;', '&egrave;', 'é', '&ecirc;', '&icirc;', '&ocirc;',
      '&ouml;', '&oslash;', '&Oslash;', '&ugrave;', '&ucirc;', '&apos;']
    const t2 = ['à', 'â', 'æ', 'è', 'é', 'ê', 'î', 'ô',
      'ö', 'ø', 'Ø', 'ù', 'û', "'"]
    let i
    for (i = 0; i < t1.length; i++) {
      ch = ch.replace(new RegExp(t1[i], 'g'), t2[i])
    }
    return ch
  },
  /**
   * Fonction remplaçant dans la chaîne ch toutes les balises écrites avec des caractères spéciaux £
   * par des balises normales du type <...>
   * @param {string} ch : La chaîne à traiter contenant les balises spéciales
   * @returns {string} : La chaîne avec les balises normales
   */
  remplaceBalises: function (ch) {
    // Certains auteurs ont utilisé les codes £lt; et £gt;
    // Inutile car quand on parse avec getAttribute pour avoir le texte le balises sont déjà remplacées
    /*
    ch = ch.replace(/£lt;/gi,"£lt£");
    ch = ch.replace(/£gt;/gi,"£gt£");
    */
    // Par contre si elles ont déjà été remplacées et utilisaient des majuscules il faut mettre des minuscules
    ch = ch.replace(/<B>/g, '<b>')
    ch = ch.replace(/<\/B>/g, '</b>')
    ch = ch.replace(/<I>/g, '<i>')
    ch = ch.replace(/<\/I>/g, '</i>')
    ch = ch.replace(/<U>/g, '<u>')
    ch = ch.replace(/<\/U>/g, '</u>')

    ch = ch.replace(/£lt£i£gt£/gi, '<i>')
    ch = ch.replace(/£i£/gi, '<i>')
    ch = ch.replace(new RegExp('£lt£/i£gt£', 'gi'), '</i>')
    ch = ch.replace(new RegExp('£/i£', 'gi'), '</i>')
    ch = ch.replace(/£lt£b£gt£/gi, '<b>')
    ch = ch.replace(/£b£/gi, '<b>')
    ch = ch.replace(new RegExp('£lt£/b£gt£', 'gi'), '</b>')
    ch = ch.replace(new RegExp('£/b£', 'gi'), '</b>')
    ch = ch.replace(/£lt£u£gt£/gi, '<u>')
    ch = ch.replace(/£u£/gi, '<u>')
    ch = ch.replace(new RegExp('£lt£/u£gt£', 'gi'), '</u>')
    ch = ch.replace(new RegExp('£/u£', 'gi'), '</u>')
    ch = ch.replace(/£lt£br£gt£/gi, '<br>')
    ch = ch.replace(new RegExp('£lt£br/£gt£', 'gi'), '<br>')
    ch = ch.replace(/£br£/gi, '<br>')
    ch = ch.replace(new RegExp('£br/£', 'gi'), '<br>')
    ch = ch.replace(/£lt£font/gi, '<font')
    ch = ch.replace(new RegExp('£lt£/font£gt£', 'gi'), '</font>')
    // Remplacement de balises exotiques utilisées par certains
    ch = ch.replace(/£lt£bold£gt£/gi, '<b>')
    ch = ch.replace(new RegExp('£lt£/bold£gt£', 'gi'), '</b>')
    // remplacement des £lt£ et £gt£ utiliséscomme caractères
    ch = ch.replace(/£lt£/gi, '<')
    ch = ch.replace(/£gt£/gi, '>')
    ch = ch.replace(/£inferieurstrict£/gi, '<')
    ch = ch.replace(/£superieurstrict£/gi, '>')
    // Remplacement des guillemets
    ch = ch.replace(/£guillemet£/gi, '"')
    return ch
  },
  /**
   * Fonction renvoyant une chaîne où les caractères spéciaux de Flash de ch sont remplacés par
   * le caractère UTF8 correspondant
   * @param {string} ch : La chaîne à traiter
   */
  remplaceCarSpe: function (ch) {
    let i; let cha; let chb
    let s = ch
    if (ch.indexOf('£') !== -1) {
      const a = ['alpha2', 'plus', 'moins', 'fois', 'divise', 'petitf', 'petitebarre', 'grandebarre', 'prime', 'seconde',
        'puceronde', 'grandC', 'euler', 'petitg', 'petith', 'Ironde', 'Lronde', 'lronde', 'grandN',
        'Pronde', 'grandQ', 'Rronde', 'grandR', 'grandZ', 'Eronde', 'Fronde', 'Nronde', 'flecheG',
        'flecheH', 'flecheD', 'flecheB', 'flecheDG', 'flecheGD', 'flecheHB', 'flecheBH', 'croissant', 'decroissant',
        'alaligneadroite', 'alaligneagauche', 'doubleflecheG', 'doubleflecheD', 'doubleflecheDG', 'doubleflecheGD',
        'flecheGbarre', 'flecheDbarre', 'flecheGcreuse', 'flecheHcreuse', 'flecheDcreuse', 'flecheBcreuse',
        'qqsoit', 'pourtout', 'quelquesoit', 'complement', 'differentielpartiel', 'ilexiste',
        'ilnexistepas', 'vide', 'nabla', 'appartienta', 'nappartientpasa', 'contient',
        'petitcontient', 'grandproduit', 'grandcoproduit', 'grandesomme', 'petitebarrefine',
        'moinsouplus', 'antislash', 'asterisque', 'racine', 'proportionnela',
        'infini', 'angle', 'anglespherique', 'divise', 'nedivisepas',
        'parallelea', 'nestpasparallelea', 'etlogique', 'oulogique', 'inter',
        'intersection', 'union', 'integrale', 'doubleintegrale', 'tripleintegrale',
        'integralecurviligne', 'integralesurfacique', 'integralevolumique', 'egaleasymptotiquea', 'environdroit',
        'environegala', 'environ', 'egalpardefinition', 'differentde', 'identiquea',
        'inferieura', 'superieura', 'inclusdans', 'contient', 'nestpasinclusdans',
        'necontientpas', 'sommedirecte', 'differencedirecte', 'produittensoriel', 'divisiondirecte',
        'produitdirect', 'top', 'perpendiculairea', 'antecedentde', 'imagede',
        'angledroitarc', 'point', 'pv']
      const b = ['α', '+', '-', '×', '÷', 'f', '–', '—', "'", '"',
        '•', 'ℂ', 'ℂ', 'ℊ', 'ℏ', 'ℑ', 'ℒ', 'ℓ', 'ℕ',
        '℘', 'ℚ', 'ℜ', 'ℝ', 'ℤ', 'ℰ', 'ℱ', 'ℵ', '←',
        '↑', '→', '↓', '↔', '↔', '↕', '↕', '↗', '↘',
        '↳', '↵', '⇐', '⇒', '⇔', '⇔',
        '⇤', '⇥', '⇦', '⇧', '⇨', '⇩',
        '∀', '∀', '∀', '∁', '∂', '∃',
        '∄', '∅', '∇', '∈', '∉', '∋',
        '∍', '∏', '∐', '∑', '−',
        '∓', '∖', '∗', '√', '∝',
        '∞', '∡', '∢', '∣', '∤',
        '//', '∦', '∧', '∨', '∩',
        '∩', '∪', '∫', '∬', '∭',
        '∮', '∯', '∰', '≃', '≃',
        '≅', '≈', '≝', '≠', '≡',
        '≤', '≥', '⊂', '⊃', '⊄',
        '⊅', '⊕', '⊖', '⊗', '⊘',
        '⊙', '⊤', '⊥', '⊶', '⊷',
        '⊾', '⋅', ';']
      for (i = 0; i < a.length; i++) {
        cha = '£' + a[i] + '£'
        chb = b[i]
        if (s.indexOf(cha) !== -1) s = s.replace(new RegExp(cha, 'gi'), chb)
      }
    }
    return s
  },
  /**
   * Fonction renvoyant l'idice dans la chaîne chaine de l'accolade fermante
   * correspondant à l'accolade ouvrante dont l'indice dans la chaîne est pdebut
   * Avant appel,l le caractère d'indice pdebut de la chaîne ch doit contenir
   * une parenthèse ouvrante.
   */
  accoladeFermante: function (chaine, pdebut) {
    let p, ch, somme

    somme = 1
    p = pdebut + 1
    while (p < chaine.length) {
      ch = chaine.charAt(p)
      if (ch === '{') { somme++ } else {
        if (ch === '}') { somme-- }
      }
      if (somme === 0) break
      p++
    }
    if (somme === 0) return p
    else return -1 // On renvoie -1 si pas trouvé
  },
  /**
   * Fonction renvoyant true si ch conteint une balise LaTeX : fraction, racine carrée,
   * puissance, indice, chapeau, parenthèses, crochets, valeur abolue, norme,
   * vecteur ou texte
   * @param {type} ch
   * @returns {Boolean}
   */
  contientBaliseLaTeX: function (ch) {
    return (ch.indexOf('\\frac') !== -1) || (ch.indexOf('\\sqrt') !== -1) ||
      (ch.indexOf('}^{') !== -1) || (ch.indexOf('}_{') !== -1) ||
      (ch.indexOf('\\widehat{') !== -1) || (ch.indexOf('\\left[') !== -1) ||
      (ch.indexOf('\\left(') !== -1) || (ch.indexOf('\\left|') !== -1) ||
      (ch.indexOf('\\left\\|') !== -1) || (ch.indexOf('\\overrightarrow{') !== -1) ||
      (ch.indexOf('\\text{') !== -1)
  }

}
kernel.cos30 = Math.cos(30 * kernel.convDegRad)
/**
 * Fonction renvoyant une chaîne de carcatère représentant en svg la couleur
 * correspondant au contenu de ch (couleur en Flash)
 * @param {string} ch
 * @returns {string}
 */
kernel.couleur = function (ch) {
  let i, s, t
  const cc1 = ['noir', 'rouge', 'vert', 'bleu', 'blanc', 'gris', 'darkorange']
  const cc2 = ['black', 'red', 'green', 'blue', 'white', 'grey', 'maroon']
  if (ch === '0') return 'black'
  for (i = 0; i < cc1.length; i++) {
    if (cc1[i] === ch) return cc2[i]
  }
  if (ch.substring(0, 2) === '0x') {
    s = '000000' + ch.substring(2)
    t = s.substring(s.length - 6)
    ch = '#' + t
  } else {
    if (kernel.chiffre(ch.charAt(0))) {
      ch = parseFloat(ch).toString(16)
      s = '000000' + ch
      t = s.substring(s.length - 6)
      ch = '#' + t
    } else {
      if (ch.charAt(0) === '#') {
        s = '000000' + ch.substring(1)
        t = s.substring(s.length - 6)
        ch = '#' + t
      }
    }
  }
  return ch
}

/**
 * Fonction renvoyant true si les vecteurs u et v sont quasi colinéaires
 * @param {kernel.vect} u
 * @param {kernel.vect} v
 * @returns {boolean}
 */
kernel.colineaires = function (u, v) {
  const n1 = u.norme()
  const n2 = v.norme()
  if (kernel.zero(n1) || kernel.zero(n2)) return true
  else return (kernel.zero((u.x * v.y - u.y * v.x) / n1 / n2))
}
/**
 * Fonction renvoyant true si les vecteurs u et v sont quasi colinéaires
 * de même sens
 * @param {kernel.vect} u
 * @param {kernel.vect} v
 * @returns {boolean}
 */
kernel.colineairesMemeSens = function (u, v) {
  return kernel.colineaires(u, v) && (u.x * v.x + u.y * v.y >= 0)
}
/**
 * Fonction renvoyant l'indice de la nb ième virgule dans la chaîne ch
 * à partir de l'indice deb en sauta,t le contenu des parenthèses
 * @param {type} chaine
 * @param {type} deb
 * @param {type} nb
 * @returns {Integer}
 */
kernel.indiceVirgule = function (chaine, deb, nb) {
  let ch; let indpf
  let k = 0
  let p = deb
  while (p < chaine.length) {
    ch = chaine.charAt(p)
    if (ch === '(') {
      indpf = kernel.indiceParentheseFermante(chaine, p)
      if (indpf === -1) return -1
      else p = indpf
    } else {
      if (ch === ',') k++
      if (k === nb) return p
    }
    p++
  }
  return -1
}
/**
 * Cette fonction permet de trouver les meilleures graduations a afficher pour un repere.
 * Elle retourne la plus petite de ces graduations, afin que des nombres "ronds" soient affichés.
 * Fonction reprise à partir du code de la version Flash et servant pour les
 * repères et quadrillages
 * @param {Float} mini
 * @param {Float} maxi
 * @param {Float} unite
 * @returns {Float}
 */
kernel.determiner_graduations = function (mini, maxi, unite) {
  let debut_trace
  // lorsque 0 est entre les bornes, on part de 0 et on cherche le début du tracé
  if (maxi * mini < 0) {
    debut_trace = -Math.floor(-mini / unite) * unite
  }
  // en cas de puissance de 10 entre les bornes, on prend
  else if (Math.ceil(Math.log(Math.abs(mini)) / Math.LN10) !== Math.ceil(Math.log(Math.abs(maxi)) / Math.LN10)) {
    if (mini < 0) {
      debut_trace = -Math.pow(10, Math.floor(Math.log(Math.abs(mini)) / Math.LN10))
    } else {
      debut_trace = Math.pow(10, Math.ceil(Math.log(Math.abs(mini)) / Math.LN10))
    }
    debut_trace = debut_trace - Math.floor((debut_trace - mini) / unite) * unite
  }
  // dans tous les autres cas, on fait ce qu'on peut
  else {
    debut_trace = kernel.valeur_approchee(mini, Math.floor(Math.log(unite) / Math.LN10))
    if (debut_trace < mini) {
      debut_trace += unite
    }
  }
  return debut_trace
}
/**
 * Fonction récursive appelée lorsque l'affichage de texte n'utilise pas le LaTeX
 * Elle traite les balises u, i, b et font pour ajouter à txt (qui est élément
 * graphique svg text des tspans correspondants.
 * @param {String} : La chaîne contenant le texte avec balises éventuelles
 * @param {kernel.infoBalise} infoBalise : un objet qui contient les caractéristiques du texte, à savoir
 * bold ou non, italique ou non, souligné ou non, couleur et fonte utilisée
 * @param {svg.text} txt : L'élément text de svg auquel seront rajoutés les tspan créés
 * @param {Boolean} debutLigne : true si l'affichage du prochain tspan doit se faire en début de ligne
 * @param {Integer} y : le paramètre y du prochain tspan à créer
 */
kernel.traiteBalise = function (ch, infoBalise, txt, debutLigne, y) {
  if (ch === '') return
  let stylespan; let indfb; let ind1; let ind2; let fonte; let couleur; let taille; let inddeb; let info
  const ind = ch.search(/<b>|<i>|<u>|<font/)
  const tspan = document.createElementNS(kernel.svgsn, 'tspan')
  tspan.setAttribute('pointer-events', 'none')
  if ((ind === -1) || (ind > 0)) { // Il y a du texte
    stylespan = ''
    // if (infoBalise.couleur !== "") stylespan += "fill:" + infoBalise.couleur+";";
    if (infoBalise.couleur) stylespan += 'fill:' + infoBalise.couleur + ';'
    if (infoBalise.bold) stylespan += 'font-weight:bold;'
    if (infoBalise.italic) stylespan += 'font-style:italic;'
    if (infoBalise.underline) stylespan += 'text-decoration:underline;'
    if (infoBalise.fontface !== '') stylespan += 'font-family:' + infoBalise.fontface + ';'
    else stylespan += 'font-family: "Times New Roman", Times, serif;'
    stylespan += 'font-size:' + infoBalise.taille + 'px;'
    tspan.setAttribute('style', stylespan)
    if (debutLigne) {
      tspan.setAttribute('x', 0)
      debutLigne = false
    }
    tspan.setAttribute('y', y)
    const ch2 = (ind === -1) ? ch : ch.substring(0, ind)
    tspan.appendChild(document.createTextNode(ch2))
    txt.appendChild(tspan)
    if (ind > 0) kernel.traiteBalise(ch.substring(ind), infoBalise, txt, debutLigne, y)
    // else ch = "";
  } else {
    if (ch.indexOf('<b>') === 0) { // Balise bold
      info = new kernel.infoBalise(true, infoBalise.italic, infoBalise.underline, infoBalise.couleur, infoBalise.fontface)
      indfb = kernel.indiceFinBalise(ch)
      if (indfb === -1) kernel.traiteBalise(ch.substring(3), info, txt, debutLigne, y)
      else kernel.traiteBalise(ch.substring(3, indfb - 4), info, txt, debutLigne, y)
    } else {
      if (ch.indexOf('<i>') === 0) { // Balise italique
        info = new kernel.infoBalise(infoBalise.bold, true, infoBalise.underline, infoBalise.couleur, infoBalise.fontface)
        indfb = kernel.indiceFinBalise(ch)
        if (indfb === -1) kernel.traiteBalise(ch.substring(3), info, txt, debutLigne, y)
        else kernel.traiteBalise(ch.substring(3, indfb - 4), info, txt, debutLigne, y)
      } else {
        if (ch.indexOf('<u>') === 0) { // Balise souigné
          info = new kernel.infoBalise(infoBalise.bold, infoBalise.italic, true, infoBalise.couleur, infoBalise.fontface)
          indfb = kernel.indiceFinBalise(ch)
          if (indfb === -1) kernel.traiteBalise(ch.substring(3), info, txt, debutLigne, y)
          else kernel.traiteBalise(ch.substring(3, indfb - 4), info, txt, debutLigne, y)
        } else {
          if (ch.indexOf('<font') === 0) {
            indfb = kernel.indiceFinBalise(ch)
            if (indfb === -1) indfb = ch.length
            ind1 = ch.indexOf('face="')
            if (ind1 !== -1) {
              ind2 = ch.indexOf('"', ind1 + 6)
              if (ind2 !== -1) { fonte = ch.substring(ind1 + 6, ind2) } else fonte = ''
            } else fonte = ''
            couleur = ''
            ind1 = ch.indexOf('couleur="')
            if (ind1 !== -1) {
              ind2 = ch.indexOf('"', ind1 + 9)
              if (ind2 !== -1) {
                couleur = kernel.couleur(ch.substring(ind1 + 9, ind2))
              }
            } else {
              ind1 = ch.indexOf('color="')
              if (ind1 !== -1) {
                ind2 = ch.indexOf('"', ind1 + 7)
                if (ind2 !== -1) {
                  couleur = kernel.couleur(ch.substring(ind1 + 7, ind2))
                }
              }
            }
            ind1 = ch.indexOf('size="')
            if (ind1 !== -1) {
              ind2 = ch.indexOf('"', ind1 + 6)
              if (ind2 !== -1) { taille = ch.substring(ind1 + 6, ind2) } else taille = infoBalise.taille
            }

            info = new kernel.infoBalise(infoBalise.bold, infoBalise.italic, infoBalise.underline, couleur, fonte, taille)
            inddeb = ch.indexOf('>') // Recherche du > de la balise <font>
            if (ch.search(new RegExp('</font>', 'i')) !== -1) { kernel.traiteBalise(ch.substring(inddeb + 1, indfb - 7), info, txt, debutLigne, y) } else kernel.traiteBalise(ch.substring(inddeb + 1), info, txt, debutLigne, y)
          }
        }
      }
    }
  }
}
/**
 * Fonction renvoyant true si la chaîne ch contient des codes spéciaux de maths en flash
 * sauf les £e() et £i() simples.
 * Si les arguments de £e() ou £i() contiennent des appels à des balises ou d'autres
 * appels à £e() et £i() renvoie true car alors il faut utiliser le LaTeX pour représenter la formule.
 * Si expind est true on cherche aussi les puissances et indices
 * @param {string} ch
 * @returns {Boolean}
 */
kernel.necessiteLatex = function (ch) {
  // Les codes e (exposant) et i (idice) ne nécessitent pas l'utilisation de MathJax
  if (['a', 'c', 'd', 'f', 'g', 'n', 'p', 'r', 's', 'u', 'v'].some(code => ch.includes(`£${code}(`))) return true
  // Si la formule contient des puissances ou des indices utilisant elle-mêmes des balises
  // puissances, indices ou font il faut passer par le LaTeX donc on renvoie true
  let ind, indparf, s
  let ch1 = ch
  while ((ind = ch1.search(/£e\(|£i\(/g)) !== -1) {
    indparf = kernel.indiceParentheseFermante(ch1, ind + 3)
    if (indparf === -1) indparf = ch1.length
    s = ch1.substring(ind, indparf)
    if (s.search(/£e\(|£i\(£lt£font/g) !== -1) return true
    if (indparf === ch1.length) return false
    else ch1 = s.substring(indparf + 1)
  }
  ch1 = ch
  // Si la formule contient des balise font contenant des indices ou exposants
  // il faut aussi passer par le LaTeX donc on renvoie true
  while ((ind = ch1.search(/£lt£font/g)) !== -1) {
    indparf = kernel.indiceFinBalise(ch1.substring(ind))
    if (indparf === -1) indparf = ch1.length
    else indparf += ind
    s = ch1.substring(ind, indparf)
    if (s.search(/£e\(|£i\(/g) !== -1) return true
    if (indparf === ch1.length) return false
    else ch1 = s.substring(indparf + 1)
  }
  return false
}

/**
 * Fonction récursive renvoyant une chaîne LaTeX représentant la chaîne contenue dans s
 * @param {string} s : la chaîne à traiter (qui représente une ligne dans le cas de plusieurs lignes)
 * @param {Boolena} btexte : Si true, le contenut renvoyé est encadré par une balise \text
 */
kernel.getMaths = function (s, btexte) {
  let ind, indpf, indv, ind1, ind2, inddeb, ch2, couleur, ret, indv1, indv2, indv3, car
  const ch = s
  if (ch === '') return ''
  // Traitement des balises Font
  // On ne traite que les changements de couleur
  while ((ind = ch.indexOf('<font')) !== -1) {
    couleur = null
    ch2 = ch.substring(ind)
    indpf = kernel.indiceFinBalise(ch2)
    ind1 = ch2.indexOf('couleur="')
    if (ind1 !== -1) {
      ind2 = ch2.indexOf('"', ind1 + 9)
      if (ind2 !== -1) couleur = kernel.couleur(ch2.substring(ind1 + 9, ind2))
    } else {
      ind1 = ch2.indexOf('color="')
      if (ind1 !== -1) {
        ind2 = ch2.indexOf('"', ind1 + 7)
        if (ind2 !== -1) couleur = kernel.couleur(ch2.substring(ind1 + 7, ind2))
      }
    }
    if (couleur != null) { // On ne traite que les changements de couleur
      inddeb = ind + ch2.indexOf('>') + 1 // Pointe sur le début concerné par la balise <font
      if (indpf === -1) {
        return kernel.getMaths(ch.substring(0, ind) + '\\textcolor{' + couleur + '}{' +
          ch.substring(inddeb) + '}', btexte)
      } else {
        indpf += ind
        return kernel.getMaths(ch.substring(0, ind) + '\\textcolor{' + couleur + '}{' +
          ch.substring(inddeb, indpf - 7) + '}' + ch.substring(indpf), btexte)
      }
    } else {
      inddeb = ind + ch2.indexOf('>') + 1
      if (indpf === -1) return kernel.getMaths(ch.substring(0, ind) + ch.substring(inddeb), btexte)
      else {
        indpf += ind
        return kernel.getMaths(ch.substring(0, ind) + ch.substring(inddeb, indpf - 7) +
          ch.substring(indpf), btexte)
      }
    }
  }
  // Traitement des caractères par code hexadécimal
  while ((ind = ch.indexOf('£u(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(ch.substring(0, ind), btexte) + '\\unicode{x' + ch.substring(ind + 3, indpf) +
      '}' + kernel.getMaths(ch.substring(indpf + 1), btexte)
  }
  // Traitement des fractions
  while ((ind = ch.indexOf('£f(')) !== -1) {
    indv = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if ((indv === -1) || (indpf === -1) || (indv > indpf)) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\frac{' +
      kernel.getMaths(ch.substring(ind + 3, indv), false) + '}{' +
      kernel.getMaths(ch.substring(indv + 1, indpf), false) + '}' + kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des racines carrées
  while ((ind = ch.indexOf('£r(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\sqrt{' +
      kernel.getMaths(ch.substring(ind + 3, indpf), false) +
      '}' + kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des codes d'angle
  while ((ind = ch.indexOf('£a(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) +
      '\\widehat{' + kernel.getMaths(ch.substring(ind + 3, indpf), true) + '}' +
      kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des intégrales
  while ((ind = ch.indexOf('£g(')) !== -1) {
    indv1 = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indv2 = kernel.indiceVirgule(ch, ind + 3, 2) // Recherche de la première virgule
    indv3 = kernel.indiceVirgule(ch, ind + 3, 3) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\int_{' +
      kernel.getMaths(ch.substring(indv2 + 1, indv3), false) + '}^{' +
      kernel.getMaths(ch.substring(indv3 + 1, indpf), false) +
      '}' + kernel.getMaths(ch.substring(ind + 3, indv1), false) +
      ' d' + kernel.getMaths(ch.substring(indv1 + 1, indv2), false) +
      kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des crochets
  while ((ind = ch.indexOf('£c(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(ch.substring(0, ind), btexte) + '\\left[' + kernel.getMaths(ch.substring(ind + 3, indpf), btexte) +
      '\\right]' + kernel.getMaths(ch.substring(indpf + 1), btexte)
  }
  // Traitement des parenthèses
  while ((ind = ch.indexOf('£p(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\left(' + kernel.getMaths(ch.substring(ind + 3, indpf), btexte) +
      '\\right)' + kernel.getMaths(ch.substring(indpf + 1), btexte))
  }
  // Traitement des valeurs absolues
  while ((ind = ch.indexOf('£d(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\left|' + kernel.getMaths(ch.substring(ind + 3, indpf), false) +
      '\\right|' + kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des normes
  while ((ind = ch.indexOf('£n(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\left\\|' + kernel.getMaths(ch.substring(ind + 3, indpf), false) +
      '\\right\\|' + kernel.getMaths(ch.substring(indpf + 1), btexte))
  }
  // Traitement des indices
  while ((ind = ch.indexOf('£i(')) !== -1) {
    indv = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if ((indv === -1) || (indpf === -1) || (indv > indpf)) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '{' + kernel.getMaths(ch.substring(ind + 3, indv), false) + '}_{' +
      kernel.getMaths(ch.substring(indv + 1, indpf), false) + '}' + kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des exposants
  while ((ind = ch.indexOf('£e(')) !== -1) {
    indv = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if ((indv === -1) || (indpf === -1) || (indv > indpf)) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '{' + kernel.getMaths(ch.substring(ind + 3, indv), false) + '}^{' +
      kernel.getMaths(ch.substring(indv + 1, indpf), false) + '}' + kernel.getMaths(ch.substring(indpf + 1), btexte))
  }
  // Traitement des vecteurs
  while ((ind = ch.indexOf('£v(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMaths(kernel.getMaths(ch.substring(0, ind), btexte) + '\\overrightarrow{' + kernel.getMaths(ch.substring(ind + 3, indpf), false) +
      '}' + kernel.getMaths(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des balises <u>
  while ((ind = ch.indexOf('<u>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) return ch
    else indpf += ind
    return kernel.getMaths(ch.substring(0, ind), btexte) + '\\underline{' + kernel.getMaths(ch.substring(ind + 3, indpf - 4), true) +
      '}' + kernel.getMaths(ch.substring(indpf), btexte)
  }
  // Traitement des balises <i>
  while ((ind = ch.indexOf('<i>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) {
      return kernel.getMaths(ch.substring(0, ind), btexte) +
      '\\textit{' + kernel.getMaths(ch.substring(ind + 3), false) + '}'
    } else {
      indpf += ind
      return kernel.getMaths(ch.substring(0, ind), btexte) + '\\textit{' +
        kernel.getMaths(ch.substring(ind + 3, indpf - 4), false) + '}' +
        kernel.getMaths(ch.substring(indpf), btexte)
    }
  }
  // Traitement des balises <b>
  while ((ind = ch.indexOf('<b>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) {
      return kernel.getMaths(ch.substring(0, ind), btexte) +
      '\\textbf{' + kernel.getMaths(ch.substring(ind + 3), false) + '}'
    } else {
      indpf += ind
      return kernel.getMaths(ch.substring(0, ind), btexte) + '\\textbf{' +
        kernel.getMaths(ch.substring(ind + 3, indpf - 4), false) + '}' +
        kernel.getMaths(ch.substring(indpf), btexte)
    }
  }
  if (btexte) {
    car = ch.charAt(0)
    // if ((car === ")") || (car === ",") || (car === "}")) return ch;
    if ((car === ')') || (car === ',') || (car === '}')) return car + kernel.getMaths(ch.substring(1), btexte)
    else {
      // Même si on et en mode texte, on peut avoir au début de ch une balise \textcolor incomplète
      if (kernel.contientBaliseLaTeX(ch)) return ch
      else {
        // Il faut sauter les balises \\textcolor en tenant compte que certaines ne sont pas fermées.
        ind = ch.indexOf('\\textcolor{')
        if (ind !== -1) {
          ret = ''
          ch2 = ch
          while ((ind = ch2.indexOf('\\textcolor{')) !== -1) {
            ind1 = ch2.indexOf('}{')
            indpf = kernel.accoladeFermante(ch2, ind1 + 1)
            if (indpf === -1) {
              if (ind === 0) {
                if (ind1 + 2 !== ch2.length) ret += ch2.substring(0, ind1 + 2) + '\\text{' + ch2.substring(ind1 + 2) + '}'
                else ret += ch2
                ch2 = ''
              } else {
                if (ind1 + 2 !== ch2.length) {
                  ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2) +
                  '\\text{' + ch2.substring(ind1 + 2) + '}'
                } else ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2)
                ch2 = ''
              }
            } else {
              if (ind === 0) {
                ret += ch2.substring(0, indpf + 1)
                if (indpf < ch2.length - 1) ch2 = ch2.substring(indpf + 1)
                else ch2 = ''
              } else {
                ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2) +
                  '\\text{' + ch2.substring(ind1 + 2, indpf + 1) + '}'
                if (indpf < ch2.length - 1) ch2 = ch2.substring(indpf + 1)
                else ch2 = ''
              }
            }
          }
          if (ch2 === '') return ret
          else return ret + '\\text{' + ch2 + '}'
        } else {
          // Si la chaîne commence par une parenthèse fermante, une accolade fermante ou une virgule
          //  il s'agit d'une formule en cours et pas de mode texte
          // Si le texte commence par des espaces, pour qu'ils soient pris en compte, on rajoute des espaces
          // insécables en mode maths
          let deb = 0
          let k = 0
          while (ch.charAt(k) === ' ') {
            deb++
            k++
          }
          return '~'.repeat(deb) + '\\text{' + ch.substring(k) + '}'
        }
      }
    }
  } else return ch
}

/**
 * Fonction récursive renvoyant une chaîne LaTeX représentant la chaîne contenue dans s
 * Utilisée pour les noms devant utiliser le LaTeX pour être affichés
 * @param {string} s : la chaîne à traiter (qui représente une ligne dans le cas de plusieurs lignes)
 * @param {Boolena} btexte : Si true, le contenut renvoyé est encadré par une balise \text Test
 */
kernel.getMathsForName = function (s, btexte) {
  let ind, indpf, indv, ind1, ind2, inddeb, ch2, couleur, ret, car
  let ch = s
  if (ch === '') return ''
  // Traitement des balises Font
  // On ne traite que les changements de couleur
  while ((ind = ch.indexOf('<font')) !== -1) {
    couleur = null
    ch2 = ch.substring(ind)
    indpf = kernel.indiceFinBalise(ch2)
    ind1 = ch2.indexOf('couleur="')
    if (ind1 !== -1) {
      ind2 = ch2.indexOf('"', ind1 + 9)
      if (ind2 !== -1) couleur = kernel.couleur(ch2.substring(ind1 + 9, ind2))
    } else {
      ind1 = ch2.indexOf('color="')
      if (ind1 !== -1) {
        ind2 = ch2.indexOf('"', ind1 + 7)
        if (ind2 !== -1) couleur = kernel.couleur(ch2.substring(ind1 + 7, ind2))
      }
    }
    if (couleur !== null) { // On ne traite que les changements de couleur
      inddeb = ind + ch2.indexOf('>') + 1 // Pointe sur le début concerné par la balise <font
      if (indpf === -1) {
        return kernel.getMathsForName(ch.substring(0, ind) + '\\textcolor{' + couleur + '}{' +
          ch.substring(inddeb) + '}', btexte)
      } else {
        indpf += ind
        return kernel.getMathsForName(ch.substring(0, ind) + '\\textcolor{' + couleur + '}{' +
          ch.substring(inddeb, indpf - 7) + '}' + ch.substring(indpf), btexte)
      }
    } else {
      inddeb = ind + ch2.indexOf('>') + 1
      if (indpf === -1) return kernel.getMathsForName(ch.substring(0, ind) + ch.substring(inddeb), btexte)
      else {
        indpf += ind
        return kernel.getMathsForName(ch.substring(0, ind) + ch.substring(inddeb, indpf - 7) +
          ch.substring(indpf), btexte)
      }
    }
  }
  // Traitement des caractères par code hexadécimal
  while ((ind = ch.indexOf('£u(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\unicode{x' + ch.substring(ind + 3, indpf) +
      '}' + kernel.getMathsForName(ch.substring(indpf + 1), btexte)
  }
  // Traitement des racines carrées
  while ((ind = ch.indexOf('£r(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\sqrt{' +
      kernel.getMathsForName(ch.substring(ind + 3, indpf), false) +
      '}' + kernel.getMathsForName(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des valeurs absolues
  while ((ind = ch.indexOf('£d(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\left|' + kernel.getMathsForName(ch.substring(ind + 3, indpf), false) +
      '\\right|' + kernel.getMathsForName(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des normes
  while ((ind = ch.indexOf('£n(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\left\\|' + kernel.getMathsForName(ch.substring(ind + 3, indpf), false) +
      '\\right\\|' + kernel.getMathsForName(ch.substring(indpf + 1), btexte))
  }
  // Traitement des indices
  while ((ind = ch.indexOf('£i(')) !== -1) {
    indv = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if ((indv === -1) || (indpf === -1) || (indv > indpf)) return ch
    // rrue car il s'agit d'un nom : kernel.getMathsForName(ch.substring(ind+3,indv),true)
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '{' + kernel.getMathsForName(ch.substring(ind + 3, indv), true) + '}_{' +
      kernel.getMathsForName(ch.substring(indv + 1, indpf), false) + '}' + kernel.getMathsForName(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des exposants
  while ((ind = ch.indexOf('£e(')) !== -1) {
    indv = kernel.indiceVirgule(ch, ind + 3, 1) // Recherche de la première virgule
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if ((indv === -1) || (indpf === -1) || (indv > indpf)) return ch
    // true car il s'agit d'un affichage de nom : kernel.getMathsForName(ch.substring(ind+3,indv),true)
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '{' + kernel.getMathsForName(ch.substring(ind + 3, indv), true) + '}^{' +
      kernel.getMathsForName(ch.substring(indv + 1, indpf), false) + '}' + kernel.getMathsForName(ch.substring(indpf + 1), btexte))
  }
  // Traitement des vecteurs
  while ((ind = ch.indexOf('£v(')) !== -1) {
    indpf = kernel.indiceParentheseFermante(ch, ind + 2)
    if (indpf === -1) return ch
    return kernel.getMathsForName(kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\overrightarrow{' + kernel.getMathsForName(ch.substring(ind + 3, indpf), false) +
      '}' + kernel.getMathsForName(ch.substring(indpf + 1), btexte), btexte)
  }
  // Traitement des balises <u>
  while ((ind = ch.indexOf('<u>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) return ch
    else indpf += ind
    return kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\underline{' + kernel.getMathsForName(ch.substring(ind + 3, indpf - 4), true) +
      '}' + kernel.getMathsForName(ch.substring(indpf), btexte)
  }
  // Traitement des balises <i>
  while ((ind = ch.indexOf('<i>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) {
      return kernel.getMathsForName(ch.substring(0, ind), btexte) +
      '\\textit{' + kernel.getMathsForName(ch.substring(ind + 3), false) + '}'
    } else {
      indpf += ind
      return kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\textit{' +
        kernel.getMathsForName(ch.substring(ind + 3, indpf - 4), false) + '}' +
        kernel.getMathsForName(ch.substring(indpf), btexte)
    }
  }
  // Traitement des balises <b>
  while ((ind = ch.indexOf('<b>')) !== -1) {
    indpf = kernel.indiceFinBalise(ch.substring(ind))
    if (indpf === -1) {
      return kernel.getMathsForName(ch.substring(0, ind), btexte) +
      '\\textbf{' + kernel.getMathsForName(ch.substring(ind + 3), false) + '}'
    } else {
      indpf += ind
      return kernel.getMathsForName(ch.substring(0, ind), btexte) + '\\textbf{' +
        kernel.getMathsForName(ch.substring(ind + 3, indpf - 4), false) + '}' +
        kernel.getMathsForName(ch.substring(indpf), btexte)
    }
  }
  if (btexte) {
    // Même si on et en mode texte, on peut avoir au début de ch une balise \textcolor incomplète
    if (kernel.contientBaliseLaTeX(ch)) return ch
    else {
      // Il faut sauter les balises \\textcolor en tenant compte que certaines ne sont pas fermées.
      ind = ch.indexOf('\\textcolor{')
      if (ind !== -1) {
        ret = ''
        ch2 = ch
        while ((ind = ch2.indexOf('\\textcolor{')) !== -1) {
          ind1 = ch2.indexOf('}{')
          indpf = kernel.accoladeFermante(ch2, ind1 + 1)
          if (indpf === -1) {
            if (ind === 0) {
              if (ind1 + 2 !== ch2.length) ret += ch2.substring(0, ind1 + 2) + '\\text{' + ch2.substring(ind1 + 2) + '}'
              else ret += ch2
              ch2 = ''
            } else {
              if (ind1 + 2 !== ch2.length) {
                ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2) +
                '\\text{' + ch2.substring(ind1 + 2) + '}'
              } else ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2)
              ch2 = ''
            }
          } else {
            if (ind === 0) {
              ret += ch2.substring(0, indpf + 1)
              if (indpf < ch2.length - 1) ch2 = ch2.substring(indpf + 1)
              else ch2 = ''
            } else {
              ret += '\\text{' + ch2.substring(0, ind) + '}' + ch2.substring(ind, ind1 + 2) +
                '\\text{' + ch2.substring(ind1 + 2, indpf + 1) + '}'
              if (indpf < ch2.length - 1) ch2 = ch2.substring(indpf + 1)
              else ch2 = ''
            }
          }
        }
        if (ch2 === '') return ret
        else return ret + '\\text{' + ch2 + '}'
      } else {
        // Si la chaîne commence par une parenthèse fermante, une accolade fermante ou une virgule
        //  il s'agit d'une formule en cours et pas de mode texte
        car = ch.charAt(0)
        if ((car === ')') || (car === ',') || (car === '}')) return ch
        else {
          // Si on est en modetexte et que la chaîne commence par des espaces, pour qu'ils soient pris en compte
          // on va, pour ces espaces, rester en mode maths et les remplacer par des ~ pour avoir des espaces insécables.
          let deb = ''
          while (ch.indexOf(' ') === 0) {
            deb += '~'
            ch = ch.substring(1)
          }
          return deb + '\\text{' + ch + '}'
        }
      }
    }
  } else return ch
}
/**
 * Fontion qui, dans le cas d'utilisation du LaTeX, remplace les caractères accentués
 * qui ne sont pas bien traités par MathJax par des codes LaTeX
 * @param {string} ch
 * @returns {string|iep.traiteAccents.st} : La chaîne avec les caractères remplacés
 */
kernel.traiteAccents = function (ch) {
  let indpf, st, i, car, car2, bool, ind
  const a = 'éèàùâêô'
  const b = ['acute', 'grave', 'grave', 'grave', 'hat', 'hat', 'hat']
  const c = 'eeauaeo'
  // On traite les £virg£ et £virg£
  ch = ch.replace(/£virg£/gi, ',')
  ch = ch.replace(/£virgule£/gi, ',')
  bool = false
  for (i = 0; i < a.length; i++) bool = bool || (ch.indexOf(a.charAt(i)) !== 0)
  if (!bool || ch.indexOf('\\text{') === -1) return ch
  let res = ''
  let inddeb = 0
  while (((ind = ch.indexOf('\\text{', inddeb)) !== -1) && (inddeb < ch.length)) {
    indpf = kernel.accoladeFermante(ch, ind + 6)
    if (indpf === -1) break
    res = res + ch.substring(inddeb, ind)
    st = ch.substring(ind + 6, indpf + 1)
    for (i = 0; i < a.length; i++) {
      car = a.charAt(i)
      car2 = c.charAt(i)
      if (st.charAt(0) === car) st = '\\' + b[i] + '{' + car2 + '}' + '\\text{' + st.substring(1)
      if (st.charAt(st.length - 1) === car) { st = st.substring(0, st.length - 1) + '\\' + b[i] + '{' + car2 + '}' }
      st = st.replace(new RegExp(car, 'g'), '}\\' + b[i] + '{' + car2 + '} \\text{')
    }
    // Impossible de traite le c cédille
    // // Pour le lecteur IEP je laisse comme ça
    // st = st.replace(new RegExp("ç","g"),"c");
    bool = false
    for (i = 0; i < a.length; i++) bool = bool || (st.indexOf('\\' + b[i]) === 0)
    if (bool) res = res + st
    else res = res + '\\text{' + st
    inddeb = indpf + 1
  }
  if (inddeb < ch.length) res = res + ch.substring(inddeb)
  return res
}
/**
 * Fonction de log en dev (ne fait rien en prod)
 * @param {*} … autant d'arguments que l'on veut, les erreur seront envoyées à console.error et le reste à console.log
 */
/*
kernel.log = function () {
  if (kernel.isDev && typeof console !== "undefined" && console.log && console.error) {
    var i, arg;
    for (i = 0; i < arguments.length; i++) {
      arg = arguments[i];
      if (arg instanceof Error) console.error(arg);
      else console.log(arg);
    }
  }
}
*/

/**
 * Le namespace svg
 * @type {string}
 */
// kernel.svgsn = "http://www.w3.org/2000/svg";

module.exports = kernel
